import { FC, useEffect, useState } from "react"
import IconButton from "@mui/material/IconButton"

import * as api from "@/app/data/tribeSwaggerApi"
import { selectUserId } from "@/app/data/appTokensStore"
import { useAppSelector } from "@/app/hooks"
import { useIsAuthorizedUser } from "@/hooks/useIsAuthorizedUser"

import LikeIcon from "@/assets/svg/menu-icons-pack/favorite-icon-menu.svg?react"

interface FavoritesButtonProps {
  id: number
  isFavorite: boolean
  onClick?: () => void
}
const  FavoritesButton: FC<FavoritesButtonProps> = ({ isFavorite, id }) => {
  const [isSelected, setSelected] = useState<boolean>(isFavorite)
  const isUserAuth = useIsAuthorizedUser()
  const [add, { isSuccess }] = api.useSaveEventToFavoritesMutation()
  const userId = useAppSelector(selectUserId)
  const [remove, { isSuccess: isRemoveSuccess }] = api.useDeleteEventFromFavoritesMutation()

  useEffect(() => {
    setSelected(isFavorite || (isUserAuth && (isSuccess || isRemoveSuccess)))
  }, [isFavorite, isUserAuth, isSuccess, isRemoveSuccess])


  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    if (isUserAuth && userId) {
      if (isSelected) {
        remove({
          userId: userId.toString(),
          eventId: id,
        }).unwrap().then(() => {
          setSelected(false)
        })
      } else {
        add({
          userFavoriteEventDto: {
            user_id: userId.toString(),
            event_id: id,
          },
        }).unwrap().then(() => {
          setSelected(true)
        })
      }
    }
  };

  return (
    <IconButton
      onClick={handleClick}
      aria-label="add to favorites"
      sx={{
        position: "absolute",
        top: "0",
        right: "0",
        width: "32",
        height: "32",
        color: isSelected ? "var(--Schemes-Error)" : "#fef7ff",
        fill: isSelected ? "var(--Schemes-Error)" : "none",
        display: isUserAuth ? "block" : "none"
      }}
    >
      <LikeIcon/>
    </IconButton>
  )
}
export default FavoritesButton

